import {
    messageIsEmpty,
    messageIsArray,
    messageTypeIsValid,
    getResponseActions,
    getResponseActionsNamed,
    getFirstResponseActionNamed,
    hasResponseAction,
    processResponse
} from '../modules/lib-response-handler/lib/lib-response-handler';

export {
    messageIsEmpty,
    messageIsArray,
    messageTypeIsValid,
    getResponseActions,
    getResponseActionsNamed,
    getFirstResponseActionNamed,
    hasResponseAction,
    processResponse
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/ref/lib-response-handler.js